import OnBoardingContainer from "@/components/OnboardingContainer"
import RecoverNotify from "./components/RecoverNotify"



const RecoverEmail = () => {
  return (
    <OnBoardingContainer>
      <RecoverNotify />
    </OnBoardingContainer>
  )
}

export default RecoverEmail